var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-2 editor mt-1 w-100 p-1 pb-2",domProps:{"innerHTML":_vm._s(_vm.data)}})])}
var staticRenderFns = []

export { render, staticRenderFns }